import { render, staticRenderFns } from "./marea.vue?vue&type=template&id=74eded54&scoped=true&"
import script from "./marea.vue?vue&type=script&lang=js&"
export * from "./marea.vue?vue&type=script&lang=js&"
import style0 from "./marea.vue?vue&type=style&index=0&id=74eded54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eded54",
  null
  
)

export default component.exports